var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action } from "mobx";
import { ErrorModel, BetModel, StakeButtonsStatusesModel } from "../models";
import { ErrorType, BetStatus } from "../enums";
var Retriever = /** @class */ (function () {
    function Retriever(msgBus) {
        this.messageBus = msgBus;
        this.betStatus = BetStatus.Default;
        this.bets = [];
        this.errors = [];
        this.purchases = [];
        this.liveSelections = [];
        this.preliveSelections = [];
        this.isPlaceBetButtonEnabled = false;
        this.stakeButtonsStatus = Object.create({});
        this.getData = this.getData.bind(this);
        this.onMsgBusTopicReceived = this.onMsgBusTopicReceived.bind(this);
    }
    Retriever.prototype.activate = function () {
        this.getData();
    };
    Retriever.prototype.deactivate = function () {
        this.bets = [];
        this.errors = [];
        this.purchases = [];
        this.stakeButtonsStatus = Object.create({});
        this.clearSelections();
        this.messageBus.unsubscribe("sb_yourbet_topic", this.onMsgBusTopicReceived);
    };
    Retriever.prototype.getData = function () {
        this.messageBus.subscribe("sb_yourbet_topic", this.onMsgBusTopicReceived);
    };
    Retriever.prototype.onMsgBusTopicReceived = function (topic) {
        var _this = this;
        if (topic) {
            Object.keys(topic).forEach(function (x) {
                var funcName = x + "Topic";
                if (_this.checkIfFunction(funcName)) {
                    _this[funcName](topic[x]);
                }
            }, this);
        }
    };
    Retriever.prototype.actionsTopic = function (actions) {
        var _this = this;
        Object.keys(actions).forEach(function (x) {
            var funcName = x + "Action";
            if (_this.checkIfFunction(funcName)) {
                _this[funcName](actions[x]);
            }
        }, this);
    };
    Retriever.prototype.purchaseAction = function (purchases) {
        this.purchases = this.toPurchaseModels(purchases);
    };
    Retriever.prototype.errorAction = function (errors) {
        this.errors = this.toErrorModels(errors);
    };
    Retriever.prototype.placeBet = function (stake, selections) {
        var groupedSelections = this.getGroupedSelections(selections);
        var yourBetSelections = groupedSelections.live.concat(groupedSelections.prelive);
        var message = {
            actions: {
                place: {
                    stake: stake,
                    selections: yourBetSelections
                }
            }
        };
        this.messageBus.post({ sb_yourbet_topic: message });
        return message;
    };
    Retriever.prototype.updateNewOfferStatus = function (waitingBetId, isAccepted) {
        var message = {
            actions: {
                newOfferStatus: {
                    waitingBetId: waitingBetId,
                    isAccepted: isAccepted
                }
            }
        };
        this.messageBus.post({ sb_yourbet_topic: message });
        return message;
    };
    Retriever.prototype.updateOddsChangeStatus = function (isAccepted) {
        var message = {
            actions: {
                oddsChangedStatus: {
                    isOddAccepted: isAccepted
                }
            }
        };
        this.messageBus.post({ sb_yourbet_topic: message });
        return message;
    };
    Retriever.prototype.placeResultTopic = function (placeBetResponse) {
        this.purchaseResponse(placeBetResponse.purchase);
        this.selectionsResponse(placeBetResponse.selections, placeBetResponse.purchase);
        if (placeBetResponse.error) {
            this.errorResponse(placeBetResponse.error);
        }
    };
    ;
    Retriever.prototype.purchaseResponse = function (purchases) {
        this.bets = this.getBets(purchases);
        this.betStatus = this.getPurchaseStatus(purchases);
        this.purchases = this.toPurchaseModels(purchases);
    };
    Retriever.prototype.selectionsResponse = function (selections, purchases) {
        var _this = this;
        purchases.forEach(function (x) {
            if (x.liveSelectionIds) {
                var liveSelectionsToReplace = _this.mapSelectionsToIds(x.liveSelectionIds, selections, true);
                if (liveSelectionsToReplace.length > 0) {
                    _this.setCurrentSelections(liveSelectionsToReplace, true);
                }
            }
            if (x.preliveSelectionIds) {
                var preliveSelectionsToReplace = _this.mapSelectionsToIds(x.preliveSelectionIds, selections, false);
                if (preliveSelectionsToReplace.length > 0) {
                    _this.setCurrentSelections(preliveSelectionsToReplace, false);
                }
            }
        });
    };
    Retriever.prototype.errorResponse = function (errors) {
        this.errors = this.toErrorModels(errors);
    };
    Retriever.prototype.selectionsTopic = function (selections) {
        var _this = this;
        Object.keys(selections).forEach(function (x) {
            if (x === "live") {
                Object.keys(selections[x].selections).forEach(function (y) {
                    var funcName = y + "SelectionsResponse";
                    if (_this.checkIfFunction(funcName)) {
                        _this[funcName](selections[x].selections[y], true);
                    }
                }, _this);
            }
            else {
                Object.keys(selections[x].selections).forEach(function (y) {
                    var funcName = y + "SelectionsResponse";
                    if (_this.checkIfFunction(funcName)) {
                        _this[funcName](selections[x].selections[y], false);
                    }
                }, _this);
            }
        }, this);
    };
    Retriever.prototype.addSelectionsResponse = function (selectionsToAdd, isLive) {
        if (selectionsToAdd && selectionsToAdd.length > 0) {
            var currentSelections = this.getCurrentSelections(isLive)
                .concat(selectionsToAdd.map(function (x) { return (__assign({}, x, { isLive: isLive })); }));
            this.setCurrentSelections(currentSelections, isLive);
        }
    };
    Retriever.prototype.updateSelectionsResponse = function (selectionsToUpdate, isLive) {
        if (selectionsToUpdate && selectionsToUpdate.length > 0) {
            var currentSelections_1 = this.getCurrentSelections(isLive);
            selectionsToUpdate.forEach(function (x) {
                var indexToUpdate = currentSelections_1.findIndex(function (y) { return y.id === x.id; });
                if (indexToUpdate >= 0) {
                    currentSelections_1[indexToUpdate] = __assign({}, x, { isLive: isLive });
                }
            });
        }
    };
    Retriever.prototype.removeSelectionsResponse = function (selectionsToRemove, isLive) {
        if (selectionsToRemove && selectionsToRemove.length > 0) {
            var currentSelections = this.getCurrentSelections(isLive);
            currentSelections = currentSelections.reduce(function (a, b) {
                var selection = selectionsToRemove.find(function (y) { return y.id === b.id; });
                if (!selection) {
                    a.push(b);
                }
                return a;
            }, []);
            this.setCurrentSelections(currentSelections, isLive);
        }
    };
    Retriever.prototype.removeSelectionsRequest = function (selections) {
        var result = this.getRemoveSelectionsRequestMessage({ live: [], prelive: [] });
        if (selections && selections.length > 0) {
            var groupedSelections = this.getGroupedSelections(selections);
            var message = this.getRemoveSelectionsRequestMessage(groupedSelections);
            this.messageBus.post({ sb_yourbet_topic: message });
            result = message;
        }
        return result;
    };
    Retriever.prototype.retainPurchaseRequest = function (purchaseId, purchaseViewKey) {
        var message = {
            actions: {
                retainPurchase: {
                    purchaseId: purchaseId,
                    purchaseViewKey: purchaseViewKey
                }
            }
        };
        this.messageBus.post({ sb_yourbet_topic: message });
        this.clearSelections();
        return message;
    };
    Retriever.prototype.clearPurchaseRequest = function (purchaseId, purchaseViewKey) {
        var message = {
            actions: {
                clearPurchase: {
                    purchaseId: purchaseId,
                    purchaseViewKey: purchaseViewKey
                }
            }
        };
        this.messageBus.post({ sb_yourbet_topic: message });
        this.clearSelections();
        return message;
    };
    Retriever.prototype.clearAllPurchases = function (purchases) {
        var purchasesResult = purchases.reduce(function (a, purchase) {
            if (purchase.id && purchase.viewKey) {
                var currentPurchase = {
                    purchaseId: purchase.id,
                    purchaseViewKey: purchase.viewKey
                };
                a.push(currentPurchase);
            }
            return a;
        }, []);
        var message = {
            actions: {
                clearAllPurchases: purchasesResult
            }
        };
        this.messageBus.post({ sb_yourbet_topic: message });
        this.clearSelections();
        return message;
    };
    Retriever.prototype.clearSelections = function () {
        var message = this.getRemoveSelectionsRequestMessage({ live: this.liveSelections, prelive: this.preliveSelections });
        this.messageBus.post({ sb_yourbet_topic: message });
        this.betStatus = BetStatus.Default;
        this.liveSelections = [];
        this.preliveSelections = [];
        return message;
    };
    Retriever.prototype.clearPurchaseAction = function (purchaseInfo) {
        this.purchases = this.purchases.reduce(function (a, purchase) {
            if (purchase.viewKey && purchase.viewKey !== purchaseInfo.purchaseViewKey) {
                a.push(purchase);
            }
            return a;
        }, []);
        this.betStatus = BetStatus.Default;
        this.liveSelections = [];
        this.preliveSelections = [];
    };
    Retriever.prototype.changeStake = function (stake, buttonAction) {
        var _a;
        var stakeMessage = { value: stake };
        if (buttonAction) {
            stakeMessage = (_a = {
                    value: stake
                },
                _a[buttonAction] = true,
                _a);
        }
        var message = {
            actions: {
                stake: stakeMessage
            }
        };
        this.messageBus.post({ sb_yourbet_topic: message });
        return message;
    };
    Retriever.prototype.stakeButtonsStatesAction = function (obj) {
        this.stakeButtonsStatus = new StakeButtonsStatusesModel({
            plusEnabled: obj.plusEnabled || false,
            minusEnabled: obj.minusEnabled || false
        });
        return this.stakeButtonsStatus;
    };
    Retriever.prototype.placeBetButtonStateAction = function (obj) {
        this.isPlaceBetButtonEnabled = obj.isEnabled || false;
        return this.isPlaceBetButtonEnabled;
    };
    Retriever.prototype.getGroupedSelections = function (selections) {
        var groupedSelections = selections.reduce(function (grouped, selection) {
            var currentSelection = {
                id: selection.id,
                name: selection.name,
                viewKey: selection.viewKey,
                eventType: selection.eventType,
                suspended: selection.suspended
            };
            if (selection.isLive) {
                grouped.live.push(currentSelection);
            }
            else {
                grouped.prelive.push(currentSelection);
            }
            return grouped;
        }, { live: [], prelive: [] });
        return groupedSelections;
    };
    Retriever.prototype.getRemoveSelectionsRequestMessage = function (groupedSelections) {
        return {
            selections: {
                live: {
                    selections: {
                        remove: groupedSelections.live
                    }
                },
                prelive: {
                    selections: {
                        remove: groupedSelections.prelive
                    }
                }
            }
        };
    };
    Retriever.prototype.getBets = function (purchases) {
        var result = [];
        purchases.forEach(function (purchase) {
            if (purchase && purchase.bet && purchase.bet.id) {
                var betToAdd = new BetModel({ id: purchase.bet.id });
                result.push(betToAdd);
            }
        });
        return result;
    };
    Retriever.prototype.getPurchaseStatus = function (purchases) {
        var _this = this;
        var resultStatus = 0;
        purchases.forEach(function (purchase) {
            if (purchase && purchase.status) {
                Object.keys(purchase.status).forEach(function (key) {
                    if (purchase.status[key]) {
                        resultStatus = _this.getStatus(key);
                    }
                }, _this);
            }
        }, this);
        return resultStatus;
    };
    Retriever.prototype.getStatus = function (statusKey) {
        var status = {
            accepted: BetStatus.Accepted,
            rejected: BetStatus.Rejected,
            waiting: BetStatus.Waiting,
            newOffer: BetStatus.NewOffer
        };
        return status[statusKey] || BetStatus.Default;
    };
    Retriever.prototype.toPurchaseModels = function (purchases) {
        var _this = this;
        var newPurchases = purchases.reduce(function (result, purchase) {
            var indexToUpdate = _this.purchases.findIndex(function (y) { return y.id === purchase.id; });
            if (indexToUpdate !== -1) {
                var purchaseToUpdate_1 = __assign({}, _this.purchases[indexToUpdate]);
                Object.keys(purchase).forEach(function (key) {
                    if (purchase[key] !== undefined && purchase[key] !== null) {
                        purchaseToUpdate_1[key] = purchase[key];
                    }
                });
                result.push(purchaseToUpdate_1);
            }
            else {
                result.push(purchase);
            }
            return result;
        }, []);
        return newPurchases;
    };
    Retriever.prototype.mapSelectionsToIds = function (selectionIds, selections, isLive) {
        var resultSelections = [];
        selectionIds.forEach(function (x) {
            var selection = selections.find(function (y) { return y.id === x; });
            if (selection) {
                resultSelections.push(__assign({}, selection, { isLive: isLive }));
            }
        });
        return resultSelections;
    };
    Retriever.prototype.toErrorModels = function (errors) {
        var errorResult = errors.reduce(function (result, error) {
            var errorModel = new ErrorModel({});
            Object.keys(error).forEach(function (key) {
                if (key !== ErrorType.ActivationError
                    && key !== ErrorType.DeactivationError) {
                    errorModel[key] = error[key];
                }
            });
            result.push(errorModel);
            return result;
        }, []);
        return errorResult;
    };
    Retriever.prototype.setCurrentSelections = function (newSelections, isLive) {
        if (isLive) {
            this.liveSelections = newSelections;
        }
        else {
            this.preliveSelections = newSelections;
        }
    };
    Retriever.prototype.getCurrentSelections = function (isLive) {
        if (isLive) {
            return this.liveSelections;
        }
        else {
            return this.preliveSelections;
        }
    };
    Retriever.prototype.checkIfFunction = function (functionName) {
        if (this[functionName] && typeof this[functionName] === "function") {
            return true;
        }
        else {
            return false;
        }
    };
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], Retriever.prototype, "betStatus", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], Retriever.prototype, "bets", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], Retriever.prototype, "errors", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], Retriever.prototype, "purchases", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], Retriever.prototype, "liveSelections", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], Retriever.prototype, "preliveSelections", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Retriever.prototype, "stakeButtonsStatus", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], Retriever.prototype, "isPlaceBetButtonEnabled", void 0);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "deactivate", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "actionsTopic", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "purchaseAction", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "errorAction", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "placeResultTopic", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "purchaseResponse", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, Array]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "selectionsResponse", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "errorResponse", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "selectionsTopic", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, Boolean]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "addSelectionsResponse", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, Boolean]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "updateSelectionsResponse", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, Boolean]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "removeSelectionsResponse", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Number]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "retainPurchaseRequest", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Number]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "clearPurchaseRequest", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "clearAllPurchases", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "clearSelections", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "clearPurchaseAction", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "stakeButtonsStatesAction", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "placeBetButtonStateAction", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, Boolean]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "setCurrentSelections", null);
    return Retriever;
}());
export { Retriever };
//# sourceMappingURL=Retriever.js.map